export const FocusHeaderProps = {
  fixed: false,
  inverted: false
};